(function () {
  'use strict';

  var STORAGE_KEY = 'pbf_favorites';

  // ── Storage ──────────────────────────────────────────────────────────────────

  var Favorites = {
    getAll: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    },
    save: function (list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    },
    has: function (handle) {
      return this.getAll().indexOf(handle) !== -1;
    },
    add: function (handle) {
      var list = this.getAll();
      if (list.indexOf(handle) === -1) { list.push(handle); this.save(list); }
    },
    remove: function (handle) {
      this.save(this.getAll().filter(function (h) { return h !== handle; }));
    },
    toggle: function (handle) {
      if (this.has(handle)) { this.remove(handle); return false; }
      this.add(handle); return true;
    }
  };

  // ── Backdrop (shared with pbf-cart.js) ────────────────────────────────────

  function getBackdrop() {
    var el = document.getElementById('pbf-global-backdrop');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pbf-global-backdrop';
      el.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:9989;background:rgba(24,25,21,.52);pointer-events:none;opacity:0;visibility:hidden;transition:opacity .35s ease';
      document.body.appendChild(el);
    }
    return el;
  }
  function showBackdrop() {
    var b = getBackdrop(); b.style.opacity = '1'; b.style.visibility = 'visible';
  }
  function hideBackdrop() {
    var b = getBackdrop(); b.style.opacity = '0'; b.style.visibility = 'hidden';
  }

  // ── Drawer open / close ──────────────────────────────────────────────────────

  function openDrawer() {
    document.dispatchEvent(new CustomEvent('pbf:drawer:before-open', { detail: { id: 'favorites' } }));
    var drawer  = document.getElementById('pbf-favorites-drawer');
    var overlay = document.getElementById('pbf-favorites-overlay');
    if (drawer)  { drawer.classList.add('is-open');    drawer.setAttribute('aria-hidden', 'false'); }
    if (overlay) { overlay.classList.add('is-visible'); }
    document.body.classList.add('pbf-drawer-open');
    showBackdrop();
    renderDrawer();
  }

  function closeDrawer() {
    var drawer  = document.getElementById('pbf-favorites-drawer');
    var overlay = document.getElementById('pbf-favorites-overlay');
    if (drawer)  { drawer.classList.remove('is-open');    drawer.setAttribute('aria-hidden', 'true'); }
    if (overlay) { overlay.classList.remove('is-visible'); }
    document.body.classList.remove('pbf-drawer-open');
    hideBackdrop();
  }

  // ── Helpers ───────────────────────────────────────────────────────────────────

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function imageUrl(src) {
    if (!src) return '';
    return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_300x$1$3');
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // ── Render ────────────────────────────────────────────────────────────────────

  // Spiegelt de lege-cart-drawer (cart-drawer.liquid): zelfde cirkel-icoon,
  // titel/sub-classes en roze pill-CTA, zodat beide drawers één geheel voelen.
  function renderEmpty() {
    return (
      '<div class="pbf-fav-empty">' +
        '<div class="pbf-cart-empty__icon" aria-hidden="true">' +
          '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.5S4.6 16 3.1 11.3C2.1 8.1 4.1 5 7.3 5c2 0 3.5 1.1 4.7 2.7C13.2 6.1 14.7 5 16.7 5c3.2 0 5.2 3.1 4.2 6.3C19.4 16 12 20.5 12 20.5Z"/><path d="M12 8.4v9.4"/><path d="M12 12.1c-1.5-.2-2.6-1-3.2-2.3"/><path d="M12 14.6c1.5-.2 2.6-1 3.2-2.3"/></svg>' +
        '</div>' +
        '<h2 class="pbf-cart-empty__title">Je verlanglijst is leeg</h2>' +
        '<p class="pbf-cart-empty__sub">Klik op een hartje bij een plant om hem hier op te slaan.</p>' +
        '<a href="/collections/all" class="pbf-btn pbf-cart-empty__cta">Bekijk het assortiment ' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
        '</a>' +
      '</div>'
    );
  }

  function buildItemHTML(product) {
    var img = product.featured_image
      ? '<img src="' + imageUrl(product.featured_image) + '" alt="' + product.title.replace(/"/g, '&quot;') + '" class="pbf-fav-item__img" loading="lazy" width="80" height="80">'
      : '<div class="pbf-fav-item__img pbf-fav-item__img--empty"></div>';

    var firstAvail = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var multiVariant = product.variants.length > 1 && !(product.variants.length === 1 && product.variants[0].title === 'Default Title');

    var cta = multiVariant
      ? '<a href="' + product.url + '" class="pbf-btn pbf-fav-item__cta pbf-fav-item__cta--link">Bekijk product</a>'
      : '<button type="button" class="pbf-btn pbf-fav-item__cta pbf-fav-item__cta--btn" data-variant-id="' + firstAvail.id + '"' + (firstAvail.available ? '' : ' disabled') + '>' + (firstAvail.available ? 'In winkelwagen' : 'Uitverkocht') + '</button>';

    return (
      '<div class="pbf-fav-item" data-handle="' + product.handle + '">' +
        '<div class="pbf-fav-item__media"><a href="' + product.url + '" tabindex="-1">' + img + '</a></div>' +
        '<div class="pbf-fav-item__info">' +
          '<a href="' + product.url + '" class="pbf-fav-item__name">' + product.title + '</a>' +
          '<p class="pbf-fav-item__price">' + money(product.price) + '</p>' +
          '<div class="pbf-fav-item__actions">' +
            cta +
            '<button type="button" class="pbf-fav-item__remove" data-handle="' + product.handle + '" aria-label="Verwijder uit verlanglijst">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function bindItemEvents(container) {
    container.querySelectorAll('.pbf-fav-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.handle;
        Favorites.remove(handle);
        var item = container.querySelector('[data-handle="' + handle + '"]');
        if (item) {
          item.style.transition = 'opacity .25s';
          item.style.opacity = '0';
          setTimeout(renderDrawer, 280);
        }
        updateHeartButtons();
      });
    });

    container.querySelectorAll('.pbf-fav-item__cta--btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        btn.disabled = true;
        btn.textContent = 'Toevoegen…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Toegevoegd ✓';
          refreshCartCount();
          setTimeout(function () { btn.disabled = false; btn.textContent = 'In winkelwagen'; }, 2200);
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Opnieuw proberen'; });
      });
    });
  }

  function renderDrawer() {
    var container = document.getElementById('pbf-favorites-items');
    var footer    = document.getElementById('pbf-favorites-footer');
    if (!container) return;

    var handles = Favorites.getAll();
    if (handles.length === 0) {
      container.innerHTML = renderEmpty();
      if (footer) footer.style.display = 'none';
      return;
    }

    container.innerHTML = '<div class="pbf-fav-loading"><span></span><span></span><span></span></div>';

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) {
        container.innerHTML = renderEmpty();
        if (footer) footer.style.display = 'none';
        return;
      }
      container.innerHTML = valid.map(buildItemHTML).join('');
      if (footer) footer.style.display = '';
      bindItemEvents(container);
    });
  }

  // ── Favorites page (full page, same logic) ────────────────────────────────────

  function renderPage() {
    var grid = document.getElementById('pbf-favorites-page-grid');
    if (!grid) return;

    var handles = Favorites.getAll();
    if (handles.length === 0) {
      grid.innerHTML = renderPageEmpty();
      return;
    }

    grid.innerHTML = '<div class="pbf-fav-loading"><span></span><span></span><span></span></div>';

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) { grid.innerHTML = renderPageEmpty(); return; }
      grid.innerHTML = '<div class="pbf-favpage-grid">' + valid.map(buildPageCard).join('') + '</div>';
      bindPageEvents(grid);
    });
  }

  function renderPageEmpty() {
    return (
      '<div class="pbf-fav-empty pbf-fav-empty--page">' +
        '<svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5S4.6 16 3.1 11.3C2.1 8.1 4.1 5 7.3 5c2 0 3.5 1.1 4.7 2.7C13.2 6.1 14.7 5 16.7 5c3.2 0 5.2 3.1 4.2 6.3C19.4 16 12 20.5 12 20.5Z"/><path d="M12 8.4v9.4"/><path d="M12 12.1c-1.5-.2-2.6-1-3.2-2.3"/><path d="M12 14.6c1.5-.2 2.6-1 3.2-2.3"/></svg>' +
        '<h2 class="pbf-fav-empty__title">Je verlanglijst is nog leeg</h2>' +
        '<p class="pbf-fav-empty__sub">Blader door ons assortiment en klik op het hartje om een plant te bewaren.</p>' +
        '<a href="/collections/all" class="button">Bekijk alle planten</a>' +
      '</div>'
    );
  }

  function buildPageCard(product) {
    var img = product.featured_image
      ? '<img src="' + imageUrl(product.featured_image) + '" alt="' + product.title.replace(/"/g, '&quot;') + '" class="pbf-favpage-card__img" loading="lazy" width="400" height="400">'
      : '<div class="pbf-favpage-card__img-empty"></div>';

    var firstAvail = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var multiVariant = product.variants.length > 1 && !(product.variants.length === 1 && product.variants[0].title === 'Default Title');

    var cta = multiVariant
      ? '<a href="' + product.url + '" class="pbf-btn pbf-favpage-card__cta">Bekijk product</a>'
      : '<button type="button" class="pbf-btn pbf-favpage-card__cta" data-variant-id="' + firstAvail.id + '"' + (firstAvail.available ? '' : ' disabled') + '>' + (firstAvail.available ? 'In winkelwagen' : 'Uitverkocht') + '</button>';

    return (
      '<div class="pbf-favpage-card" data-handle="' + product.handle + '">' +
        '<div class="pbf-favpage-card__media">' +
          '<a href="' + product.url + '">' + img + '</a>' +
          '<button type="button" class="pbf-heart-btn pbf-heart--active pbf-favpage-card__remove" data-handle="' + product.handle + '" aria-label="Verwijder uit verlanglijst">' +
            '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 20.5S4.6 16 3.1 11.3C2.1 8.1 4.1 5 7.3 5c2 0 3.5 1.1 4.7 2.7C13.2 6.1 14.7 5 16.7 5c3.2 0 5.2 3.1 4.2 6.3C19.4 16 12 20.5 12 20.5Z"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="pbf-favpage-card__info">' +
          '<a href="' + product.url + '" class="pbf-favpage-card__name">' + product.title + '</a>' +
          '<p class="pbf-favpage-card__price">' + money(product.price) + '</p>' +
          cta +
        '</div>' +
      '</div>'
    );
  }

  function bindPageEvents(grid) {
    grid.querySelectorAll('.pbf-favpage-card__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.handle;
        Favorites.remove(handle);
        var card = grid.querySelector('[data-handle="' + handle + '"]');
        if (card) {
          card.style.transition = 'opacity .25s, transform .25s';
          card.style.opacity = '0';
          card.style.transform = 'scale(.95)';
          setTimeout(renderPage, 280);
        }
        updateHeartButtons();
      });
    });

    grid.querySelectorAll('.pbf-favpage-card__cta[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        btn.disabled = true;
        btn.textContent = 'Toevoegen…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Toegevoegd ✓';
          refreshCartCount();
          setTimeout(function () { btn.disabled = false; btn.textContent = 'In winkelwagen'; }, 2200);
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Opnieuw proberen'; });
      });
    });
  }

  // ── Cart count refresh ─────────────────────────────────────────────────────────

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
          bubble.querySelectorAll('span:not(.visually-hidden)').forEach(function (s) { s.textContent = cart.item_count; });
        });
        document.dispatchEvent(new CustomEvent('pbf:cart:refresh'));
      });
  }

  // ── Heart buttons on product cards ─────────────────────────────────────────────

  function updateHeartButtons() {
    document.querySelectorAll('[data-pbf-heart]').forEach(function (btn) {
      var handle = btn.dataset.pbfHeart;
      var active = Favorites.has(handle);
      btn.classList.toggle('pbf-heart--active', active);
      btn.setAttribute('aria-label', active ? 'Verwijder uit verlanglijst' : 'Voeg toe aan verlanglijst');
    });
    updateBadge();
  }

  function updateBadge() {
    var count = Favorites.getAll().length;
    document.querySelectorAll('.pbf-favorites-count').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ── Direct heart button binding (MutationObserver) ────────────────────────────
  // Binds a click listener directly on each [data-pbf-heart] button as it appears
  // in the DOM. This bypasses any overlay/stacking issues with event delegation.

  // Zoekt het dichtstbijzijnde element met data-pbf-heart,
  // via handmatige DOM-walk zodat SVG-naar-HTML traversal altijd werkt.
  function findHeartEl(el) {
    var cur = el;
    while (cur && cur.nodeType === 1) {
      if (cur.dataset && cur.dataset.pbfHeart !== undefined && cur.dataset.pbfHeart !== '') return cur;
      cur = cur.parentElement;
    }
    return null;
  }

  function handleHeartEvent(e) {
    var el = findHeartEl(e.target);
    if (!el) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var handle = el.dataset.pbfHeart;
    var added = Favorites.toggle(handle);
    updateHeartButtons();
    if (added) openDrawer();
  }

  function bindHeartButton(btn) {
    if (btn._pbfBound) return;
    btn._pbfBound = true;
    btn.addEventListener('click', handleHeartEvent);
  }

  function bindAllHeartButtons() {
    document.querySelectorAll('button[data-pbf-heart]').forEach(bindHeartButton);
  }

  function watchForHeartButtons() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'BUTTON' && node.dataset && node.dataset.pbfHeart) bindHeartButton(node);
          node.querySelectorAll && node.querySelectorAll('button[data-pbf-heart]').forEach(bindHeartButton);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Init ──────────────────────────────────────────────────────────────────────

  function init() {
    var closeBtn   = document.getElementById('pbf-favorites-close');
    var overlay    = document.getElementById('pbf-favorites-overlay');
    var headerBtn  = document.getElementById('pbf-favorites-btn');

    if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
    if (overlay)   overlay.addEventListener('click', closeDrawer);
    if (headerBtn) headerBtn.addEventListener('click', openDrawer);

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    document.addEventListener('pbf:drawer:before-open', function (e) {
      if (e.detail && e.detail.id !== 'favorites') closeDrawer();
    });

    // Bind hart-knoppen direct + MutationObserver voor dynamisch geladen kaarten
    bindAllHeartButtons();
    watchForHeartButtons();

    // Document-level capture listener als extra fallback
    document.addEventListener('click', function (e) {
      var el = findHeartEl(e.target);
      if (!el) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var handle = el.dataset.pbfHeart;
      if (!handle) return;
      var added = Favorites.toggle(handle);
      updateHeartButtons();
      if (added) openDrawer();
    }, true);

    updateHeartButtons();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PBFFavorites = Favorites;

})();
